import path from 'path-browserify';
import mapObject from 'map-obj';

import { PlaygroundFs, toMemfsJson, MemfsJson } from '../../state/files-store';
import { router } from '../../state/capsule-routes';
import { IExample } from '../../state/example-type';

//files are a hack to write to capsule fs. 🤕
export function mapFilesToCapsule(fs?: PlaygroundFs, example?: IExample) {
	if (!fs || !example) return undefined;

	const examplesDir = getExamplesDir(example && example.renderer);
	const json = toMemfsJson(fs.files);
	const mappedFiles = mapFilePaths(json, examplesDir);

	return mappedFiles;
}

function getExamplesDir(renderer?: string) {
	if (renderer === undefined) return '/capsule';

	const capsuleDef = router.get(renderer);
	if (!capsuleDef) return '/capsule';

	return capsuleDef.wrkDir;
}

function mapFilePaths(files: MemfsJson, wrkDir: string) {
	const translatedFiles = mapObject(files, (filepath, content) => [
		path.join(wrkDir, filepath),
		content,
	]);

	return translatedFiles;
}
